module.exports = __webpack_public_path__ + "img/catchbasin_driving.06213370.svg";